import { Injectable, inject } from '@angular/core';

import { IPostBody, IRespAccountValidate } from '@frontend/oxygen/bet-history-utils';
import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../../../../client-config/index';
import { CustomHttpClientService } from '../../../../core/custom-http-client.service';

@Injectable({ providedIn: 'root' })
export class BppAuthService {
    private readonly apiEndpoint: string | undefined;
    private readonly environment = inject(EnvironmentConfig).configuration;
    private customHttpClientService = inject(CustomHttpClientService);

    constructor() {
        this.apiEndpoint = this.environment.BPP_ENDPOINT;
    }

    validate(body: IPostBody): Observable<IRespAccountValidate> {
        return this.postData(`auth/user`, body);
    }

    private postData<T>(url: string, body: IPostBody): Observable<IRespAccountValidate> {
        return this.customHttpClientService.httpClient.post<IRespAccountValidate>(`${this.apiEndpoint}/${url}`, body, {
            withCredentials: true,
        });
    }
}
